import { AdminUserDetailPage } from "@/features/admin-user/pages/AdminUserDetail";

const AdminUserDetail = () => {
  return <AdminUserDetailPage />;
};

export default AdminUserDetail;
